var _path, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M468 101.518H266M468 101.518L442.734 73M468 101.518L442.734 130",
    stroke: "#F0FFF1",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 398.518H250M32 398.518L59.2671 370M32 398.518L59.2671 427",
    stroke: "#F0FFF1",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 246.688,
    cy: 248.822,
    r: 141.984,
    fill: "#F0FFF1",
    stroke: "#F0FFF1",
    strokeWidth: 30
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.75 175.041H307.918V189.397H264.085C264.085 189.397 278.022 204.33 278.022 214.093H307.79V227.3H279.287C279.287 227.3 273.586 271.865 218.986 269.109L285.623 341.814H259.019L191.75 271.637V256.935C191.75 256.935 224.815 257.852 240.649 248.091C253.444 240.166 251.797 235.341 252.937 230.746C253.318 229.023 251.923 227.416 250.022 227.416H191.75V214.207H251.418C252.683 214.207 253.444 213.058 252.811 212.024C250.276 207.545 243.564 197.552 234.316 195.715C222.279 193.419 191.75 192.843 191.75 192.843V175.041Z",
    fill: "#231942"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyTransfer);
export default __webpack_public_path__ + "static/media/money_transfer.155057cdeac2297eab19ff74417e8f8d.svg";
export { ForwardRef as ReactComponent };